import { useTranslation } from 'react-i18next'

import { Button, ButtonWithSpinner, Modal, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const DeleteUserConfirmationModal = ({ show, onClose, onConfirm, userName, storeName, confirming }) => {
  const { t } = useTranslation()

  return (
    <Modal title={t('Eliminar usuario')} size="l" onClose={onClose} show={show}>
      <Styles.Container>
        <Text type="bodyMRegular">
          {t(
            '{{userName}} dejará de tener acceso al Merchant Dashboard de {{storeName}}. ¿Quieres eliminarlo definitivamente?',
            { userName, storeName }
          )}
        </Text>
        <Styles.ActionsContainer>
          <Button onClick={onClose} variant="outlined" fullWidth>
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            onClick={onConfirm}
            defaultLabel={t('Confirmar y eliminar usuario')}
            loadingLabel={t('Confirmando')}
            loading={confirming}
            fullWidth
          />
        </Styles.ActionsContainer>
      </Styles.Container>
    </Modal>
  )
}

export default DeleteUserConfirmationModal
